import { addDays } from 'date-fns/addDays';
import { addHours } from 'date-fns/addHours';
import { addMonths } from 'date-fns/addMonths';
import { addYears } from 'date-fns/addYears';

export type Secret = {
  id?: string;
  userId?: string;
  applicationId: string;
  name: string;
  value?: string;
  secret?: string;
  allowedNetwork: string;
  environment: string;
  usages?: number;
  usedAt?: Date;
  expiresAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
};

export const expirationOptions = {
  'Forever': 'forever',
  'One hour': 'oneHour',
  'Six hours': 'sixHours',
  'Twelve hours': 'twelveHours',
  'One day': 'oneDay',
  'One week': 'sevenDays',
  'One month': 'oneMonth'
} as const;

export const expirationOptionsValues = Object.values(expirationOptions);
export type ValidExpirationOption = (typeof expirationOptions)[keyof typeof expirationOptions];

const conversionMap = {
  forever: () => undefined,
  oneHour: () => addHours(new Date(), 1),
  sixHours: () => addHours(new Date(), 6),
  twelveHours: () => addHours(new Date(), 12),
  oneDay: () => addDays(new Date(), 1),
  sevenDays: () => addDays(new Date(), 7),
  oneMonth: () => addMonths(new Date(), 1),
  sixMonths: () => addMonths(new Date(), 6),
  oneYear: () => addYears(new Date(), 1)
};

export const expirationTimeToDate = (option: ValidExpirationOption): Date | undefined => {
  return conversionMap[option]() ?? undefined;
};
